import React from "react";

import { Stack } from "react-bootstrap";

import CalendarComponent from "../../../calendar/components/calendarComponent/CalendarComponent";
import BoxDayInfo from "../../../calendar/components/boxDayInfo/BoxDayInfo";

import moment from "moment";

const CalendarAssociation = ({
  selectedDate,
  setSelectedDate,
  dataCalendar,
}) => {
  console.log(dataCalendar);

  console.log(dataCalendar?.[moment(selectedDate).format("DD/MM/YYYY")] ?? {});

  return (
    <Stack gap={2}>
      <CalendarComponent
        selectedDate={selectedDate}
        setSelectedDate={setSelectedDate}
        data={dataCalendar}
      />
      <BoxDayInfo
        selectedDate={selectedDate}
        setSelectedDate={setSelectedDate}
        dataOfDay={
          dataCalendar?.[moment(selectedDate).format("DD/MM/YYYY")] ?? {}
        }
        idAssociation={null}
        eventOfAssociation={true}
      />
    </Stack>
  );
};

export default CalendarAssociation;
